import React from 'react';
import { Container } from '@/components/ui';
import { NewWhitelistManagementPage as WhitelistManagementComponent } from '@/components/whitelist-management';
import { withPermissions } from '@/components/withPermissions';
import { PERMISSIONS } from '@/types/permissions';

const WhitelistManagement: React.FC = () => {
  return (
    <Container
      pt="4"
      pb="4"
      size="expand"
      className="whitelist-management-page"
    >
      <WhitelistManagementComponent />
    </Container>
  );
};

export const WhitelistManagementPage = withPermissions(WhitelistManagement, {
  requiredPermissions: [PERMISSIONS.WHITELIST_ACCESS],
  showRoleSwitcher: true,
});
